<template>
    <accordion-section title="Price" @toggle="updateOpen">
        <div v-for="retailer in product.retailers">
            <template  v-if="getPrice(retailer)">
                <h4>
                    {{retailer.name}}
                    <b-tooltip
                        class="ml-2"
                        v-if="getPrice(retailer).update_by_csv"
                        :label="__('strings.product.prices.update_by_csv')"
                        type="is-light is-warning"
                        position="is-left"
                        multilined>
                        <b-icon icon="alert" type="is-warning"></b-icon>
                    </b-tooltip>
                </h4>
                <b-field horizontal label="Price (Incl. IVA)">
                    <b-input v-model="getPrice(retailer).price" disabled></b-input>
                </b-field>
                <b-field horizontal label="Special Price">
                    <b-input v-model="getPrice(retailer).special_price" disabled></b-input>
                </b-field>
                <b-field horizontal label="Reference Price (Incl. IVA)">
                    <b-input v-model="getPrice(retailer).reference_price" disabled></b-input>
                </b-field>
            </template>
        </div>
        <product-price-history class="mt-5" :accordion-state="open" :product_id="product_id"></product-price-history>
    </accordion-section>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            open: false,
            product_id: this.$route.params.id,
            website_id: 1
        }
    },
    async mounted() {
        let storeId = 1;
        if (this.$route.params.hasOwnProperty('store')) {
            storeId = this.$route.params.store;
        }
        await axios.get('/website/store/' + storeId)
            .then(response => {
                this.website_id = response.data;
            });
    },
    methods: {
        updateOpen(state) {
            this.open = state;
        },
        getPriceByRetailer(retailer, websiteId) {
            return _.find(this.product.prices, {retailer_id: retailer.id, website_id: websiteId})
        },
        getPrice(retailer) {
            let price = this.getPriceByRetailer(retailer, this.website_id);
            return price ? price : this.getPriceByRetailer(retailer, 1);
        }
    }
}
</script>
